export default "__VITE_ASSET__BLPwSMLx__"